import { SEND_CONDITION, SEND_CONDITION_OPTIONS } from '../../../shared/constants/sendCondition';

const SEND_CONDITION_LABELS = Object.fromEntries(
  SEND_CONDITION_OPTIONS.map((option) => [option.value, option.label]),
);

// Cadence-card wording for a trigger send condition.
//  - after / before: "<n> Day(s) After|Before"
//  - day_of_month:   "Day <n> of month" (the number is the calendar day)
export function formatTriggerSendCondition({ send_condition: sendCondition, day } = {}) {
  if (sendCondition === SEND_CONDITION.DAY_OF_MONTH) {
    return `Day ${day} of month`;
  }
  const label = SEND_CONDITION_LABELS[sendCondition] ?? sendCondition ?? '';
  const dayWord = Number(day) === 1 ? 'Day' : 'Days';
  return `${day} ${dayWord} ${label}`.trim();
}
